<template>
  <component :is="name ? SvgPaths[name] : src" class="m-icon" :style="styles" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { EIconNameType } from './EIcon.type';
import SvgPaths from '@/core/components/ui/EIcon/svg-paths';

const props = withDefaults(
  defineProps<{
    name?: EIconNameType;
    src?: object;
    size?: number | string;
  }>(),
  {
    size: 24,
  },
);

const styles = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
}));
</script>

<style scoped lang="scss">
.m-icon {
  display: inline-flex;
  flex-shrink: 0;
}
</style>
